import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import ToggleButton from '../../Buttons/ToggleButton';
import BasePage from '../../../baseClasses/BasePage';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import '../UserSettings.scss';
import dataModel from '../../../models/DataModel';
import DataSource from '../../../dao/DataSource/DataSource';
import './NotificationsSettings.scss';

export class NotificationsSettings extends BasePage {
  constructor(props){
    super(props);
    NotificationsSettings.propTypes = {
      userToUpdate: PropTypes.object.isRequired,
      /** must map to a key in the user notification settings e.g. 'push_notifications' */
      notificationType: PropTypes.string.isRequired,
      settingsKey: PropTypes.string.isRequired,
      headerText: PropTypes.string,
      descriptionText: PropTypes.string,
    };

    this.logAnalytics = this.logAnalytics.bind(this);
  }

  handleUserRetrieval(user, action, acData, fetchedData) {
    this.setState ({ user,
      selected: (
        user.settings && user.settings[this.props.settingsKey] 
        ? user.settings[this.props.settingsKey].enabled 
        : false
      ),
    });
  }

  componentDidMount() {
    const currentRole = this.props.currentUser ? this.props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
    if (this.props.userToUpdate.id) {
      this.userDataSource = new DataSource('User', this.props.userToUpdate.id, { user: { role: {} } }, this.handleUserRetrieval);
      this.userDataSource.get();
    }
    else {
      const user = _.cloneDeep(this.props.userToUpdate);
      this.setState({
        user,
        selected: (
          user.settings && user.settings[this.props.settingsKey] 
          ? user.settings[this.props.settingsKey].enabled 
          : false
        ),
      });
    }
  }

  handleToggleChanged(selected) {
    const { settingsKey, userToUpdate, notificationType } = this.props;
    const { user } = this.state;
    if (user.id) {
      if (!user.settings[settingsKey]) {
        user.settings[settingsKey] = { enabled: false };
      }

      user.settings[settingsKey].enabled = selected;

      if (user.id && user.id > 0) {
        dataModel.usersDAO.updateUser(user).then((response) => {
          if (notificationType == 'push_notifications') {
            dataModel.mobileBridge.fireNativeEvent('hybrid.user-changed', { data: { token: localStorage.token } });
          }
        });
        this.logAnalytics(selected);
      }
    }
    else {
      // a new user (which we can't yet update so just copy settings back)
      userToUpdate.settings = user.settings;
    }
    this.setState({ selected: selected });
  }

  logAnalytics(selected) {
    const { notificationType } = this.props;

    if (notificationType == 'profile_email_notifications') {
      if (selected) {
        this.analyticsLogger.logNotifications('NotificationsProfileEmailOptIn');
      }
      else {
        this.analyticsLogger.logNotifications('NotificationsProfileEmailOptOut');
      }
    }
    else if (notificationType == 'settings_email_notifications') {
      if (selected) {
        this.analyticsLogger.logNotifications('NotificationsSettingsEmailOptIn');
      }
      else {
        this.analyticsLogger.logNotifications('NotificationsSettingsEmailOptOut');
      }
    }
    else if (notificationType == 'push_notifications') {
      if (selected) {
        this.analyticsLogger.logNotifications('NotificationsPushOptIn');
      }
      else {
        this.analyticsLogger.logNotifications('NotificationsPushOptOut');
      }
    }
  }

  render() {
    const { headerText, descriptionText, userToUpdate } = this.props;
    let { user } = this.state;
    if (!user){
      user = userToUpdate;
    }
    return (
      <div className="notifications-container">
        <div className="notifications-item">
          <div className="notifications-title">
            { headerText }
          </div>
          <div className="notifications-toggle">
            <ToggleButton 
              selected={this.state.selected} 
              handleClick={this.handleToggleChanged} 
            />
          </div>
        </div>
          <div className={'notification-text'}>
            { descriptionText }
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
  };
};
export default connect(mapStateToProps)(NotificationsSettings);



// WEBPACK FOOTER //
// ./src/components/UserSettings/NotificationsSettings/index.js